<template>
    <div class="card-container">
        <el-button type="default" class="button-size" @click="$router.go(-1)">返回上一级</el-button>
        <common-table  :data="tableData" :isShow="false" ref="commonTable" @handleChange="getList">
            <el-table-column prop="realName" label="会员名称"></el-table-column>
            <el-table-column prop="levelName" label="会员等级"></el-table-column>
            <el-table-column prop="rate" label="会员费率"></el-table-column>
            <el-table-column prop="profitAmt" label="分润金额（元）">
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.profitAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
            <!--<el-table-column prop="resMsg" label="备注"></el-table-column>-->
        </common-table>

    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'

    import OrganService from 'service/OrganService'
    import ChannelRateService from 'service/ChannelRateService'
    import TransactionService from 'service/TransactionService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin, validatorsMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "RepaymentDetails",
        components:{
            CommonTable
        },
        data(){
            return{
                tableData:[]
            }
        },
        mixins: [loadMixin, dialogMixin, validatorsMixin],
        mounted(){
          this.getList();
        },
        computed:{
            ...mapGetters(['serverType', 'tatId', 'userId'])
        },
        methods:{
            getList(){
                const params = {
                    odrNo:this.$route.params.id,
                    tranType: this.$route.params.tranType
                };
                this.doLoad(TransactionService.getProfitDtl,params,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.tableData = result;
                        // console.log('getProfitDtl',this.tableData);
                    });
                },'信息获取失败')
            }
        }
    }
</script>

<style scoped>
    .button-size{
        width: 120px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/TransactionManage/RepaymentDetails.vue